/**
 * @generated SignedSource<<4d2388e08774ffb2ff530fb08ae5e484>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WorkspaceSignalStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalsList_workspace$data = {
  readonly activeSignals: ReadonlyArray<{
    readonly body: string | null;
    readonly createdAtDate: {
      readonly isoString: string;
    };
    readonly expireAtDate: {
      readonly isoString: string;
    } | null;
    readonly id: string;
    readonly priorityOrder: number;
    readonly publishedAtDate: {
      readonly isoString: string;
    } | null;
    readonly signalCount: number;
    readonly status: WorkspaceSignalStatus;
    readonly title: string;
    readonly topic: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalListItem_signal">;
  }>;
  readonly id: string;
  readonly topics: ReadonlyArray<{
    readonly __typename: "OrgTopic";
  }> | null;
  readonly " $fragmentType": "WorkspaceSignalsList_workspace";
};
export type WorkspaceSignalsList_workspace$key = {
  readonly " $data"?: WorkspaceSignalsList_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalsList_workspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalsList_workspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SignalWorkspace",
      "kind": "LinkedField",
      "name": "activeSignals",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgTopic",
          "kind": "LinkedField",
          "name": "topic",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnzonedDate",
          "kind": "LinkedField",
          "name": "createdAtDate",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnzonedDate",
          "kind": "LinkedField",
          "name": "publishedAtDate",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnzonedDate",
          "kind": "LinkedField",
          "name": "expireAtDate",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priorityOrder",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceSignalListItem_signal"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "e8a3effa783b91ff904fc998ae2985cd";

export default node;
